import extend from 'extend';
import Quill from 'quill';

const Toolbar = Quill.import('modules/toolbar');

class MtToolbar extends Toolbar {
  constructor(quill, options) {
    super(quill, options);
    [].forEach.call(this.container.querySelectorAll('select.ql-size option'), (option) => {
      option.textContent = option.getAttribute('value').slice(0, 'px'.length);
      if ('14px' === option.getAttribute('value')) {
        option.setAttribute('selected', 'selected');
      }
    });
    if (this.options.toolbarCustom) {
      addCustomControls(this.container, this.options.toolbarCustom);
    }
  }
}
MtToolbar.DEFAULTS = extend(true, {}, Toolbar.DEFAULTS, {});

function addCustomControls(container, customControls) {
  const customBtns = document.createElement('div');
  customBtns.classList.add('custom-btns');
  container.appendChild(customBtns);
  customControls.forEach(function (control) {
    const qlBtn = document.createElement('span');
    qlBtn.classList.add(`ql-${control}-btn`);
    customBtns.appendChild(qlBtn);
    const qlBtnIcon = document.createElement('i');
    qlBtnIcon.classList.add('pz-icon');
    if (control === 'capture') {
      qlBtn.appendChild(qlBtnIcon);
      qlBtn.classList.add('ql-bar');
      qlBtn.setAttribute('labeltooltip', '插入视频截屏');
      qlBtnIcon.classList.add('text-white', 'icon-camera');
    } else if (control === 'tag') {
      qlBtn.appendChild(qlBtnIcon);
      qlBtn.classList.add('ql-bar-btn');
      qlBtn.setAttribute('labeltooltip', '插入时间标记');
      qlBtnIcon.classList.add('text-white', 'icon-activity');
    } else if (control === 'save') {
      const qlSubBtn = document.createElement('span');
      qlSubBtn.classList.add('ql-bar-btn');
      qlSubBtn.setAttribute('labeltooltip', '保存');
      qlBtn.appendChild(qlSubBtn);
      qlBtnIcon.classList.add('pz-icon', 'icon-save');
      qlSubBtn.appendChild(qlBtnIcon);
    }
  });
}

export { MtToolbar as default };
